import {
  Modal,
  Select,
  OutlinedInput,
  MenuItem,
  Box,
  Typography,
  InputAdornment,
  Chip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getIcon } from "../../utils/iconConfig";
import { ReactComponent as ArrowDown } from "../../assets/icons/Arrow_down.svg";
import { useQuery } from "@tanstack/react-query";
import apiClient from "../../lib/api_client";
import { toast } from "react-hot-toast";
import CustomToast from "../ui/CustomToast";
import { useMemo } from "react";

const SalesPersonModal = ({ open, onClose }) => {
  const [requestTray, setRequestTray] = useState([]);
  const [collectTray, setCollectTray] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [selectOpen, setSelectOpen] = useState({
    request: false,
    collect: false,
  });
  const clientData = JSON.parse(localStorage.getItem("ClientData"));
  const dynamicClient = JSON.parse(localStorage.getItem("DynamicClient"));
  const [requestSearchTerm, setRequestSearchTerm] = useState("");
  const [collectSearchTerm, setCollectSearchTerm] = useState("");

  const { data: requestData, refetch: refetchRequest } = useQuery({
    queryKey: ["tray-modal-requests"],
    queryFn: async () => {
      const response = await apiClient.get(`/getRequestDropdown`, {
        params: {
          clientRef: clientData?.id,
          dynamicClientNameForBJPLRef: dynamicClient?.id,
        },
      });
      return response.data?.data || [];
    },
    staleTime: 0,
    enabled: false,
  });

  const { data: collectData, refetch: refetchCollect } = useQuery({
    queryKey: ["tray-modal-collect"],
    queryFn: async () => {
      const response = await apiClient.get(`/getCollectDropdown`);
      return response.data?.data || [];
    },
    staleTime: 0,
    enabled: false,
  });

  const RequestValue =
    requestData
      ?.filter((item) => !item?.occupiedSelfRequest)
      .map((item) => item?.trayName) || [];
  const CollectValue =
    collectData
      ?.filter((item) => !item?.isCollectRequestAlreadySend)
      .map((item) => item?.trayName) || [];

  const trayStatusMap = requestData?.reduce((acc, tray) => {
    acc[tray.trayName] = tray.status;
    return acc;
  }, {});

  const handleSelectOpen = (type) => {
    setSelectOpen((prev) => ({
      request: type === "request",
      collect: type === "collect",
    }));
  };

  const handleSelectClose = () => {
    setSelectOpen({ request: false, collect: false });
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const payload = {
        requestTrays: requestTray,
        collectTrays: collectTray,
        clientRef: clientData?.id,
        dynamicClientNameForBJPLRef: dynamicClient?.id,
        purchaseNo:clientData?.purchaseNo,
      };
      const response = await apiClient.post(
        `/submitRequestAndCollectTray`,
        payload
      );
      if (response?.status === 201) {
        if (requestTray?.length > 0) {
          const requestNames = requestTray.join(" and ");
          toast?.custom((t) => (
            <CustomToast
              t={t}
              message={`Requested for ${requestNames} placed successfully!`}
            />
          ));
        }

        if (collectTray?.length > 0) {
          const collectNames = collectTray.join(" and ");
          toast?.custom((t) => (
            <CustomToast
              t={t}
              message={`Collection of ${collectNames} placed successfully!`}
            />
          ));
        }
        setRequestTray([]);
        setCollectTray([]);
        setSubmitting(false);
      } else {
        setSubmitting(false);
        toast?.custom((t) => (
          <CustomToast
            t={t}
            isError={true}
            message={`There was a error placing Request or Collection`}
          />
        ));
      }
    } catch (error) {
      setSubmitting(false);
      toast?.custom((t) => (
        <CustomToast
          t={t}
          isError={true}
          message={`There was a error placing Request or Collection`}
        />
      ));
    }
    onClose();
  };

  useEffect(() => {
    if (open) {
      refetchRequest();
      refetchCollect();
    } else {
      setRequestTray([]);
      setCollectTray([]);
    }
  }, [open, refetchRequest, refetchCollect]);

  const handleRequestChange = (event) => {
    const value = event.target.value;

    if (value?.length > 3) {
      return;
    }

    setRequestTray(typeof value === "string" ? value.split(",") : value);
  };

  const handleCollectChange = (event) => {
    const value = event.target.value;
    setCollectTray(typeof value === "string" ? value.split(",") : value);
  };

  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: "10vw",
        width: "12.5vw",
        marginTop: ".15vw",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        borderRadius: ".25vw",
        padding: ".25vw !important",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "& .MuiList-root": {
          "& .MuiMenuItem-root": {
            fontFamily: "Karla",
            padding: ".5vw .25vw !important",
            margin: "0px 0px",
            display: "flex",
            justifyContent: "flex-start",
            alignContent: "center",
            "&:hover": {
              backgroundColor: "#444444",
              color: "#FFFFFF",
              borderRadius: ".25vw",
              margin: "0px 0px",
            },
          },
        },
      },
    },
  };

  const filteredOptions = useMemo(() => {
    if (!requestSearchTerm) return RequestValue;
    return RequestValue.filter((option) =>
      option.toLowerCase().includes(requestSearchTerm.toLowerCase())
    );
  }, [requestSearchTerm, RequestValue]);

  const filteredCollectOptions = useMemo(() => {
    if (!collectSearchTerm) return CollectValue;
    return CollectValue.filter((option) =>
      option.toLowerCase().includes(collectSearchTerm.toLowerCase())
    );
  }, [collectSearchTerm, CollectValue]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent",
          backdropFilter: "none",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "65%",
          left: "85%",
          transform: "translate(-50%, -50%)",
          width: "26vw",
          bgcolor: "#FCFAFA",
          borderRadius: ".4vw",
          outline: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            mb: "2vw",
            position: "relative",
            m: 3,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              fontSize: ".8vw",
              color: "#595959",
              lineHeight: "1.1vw",
              textAlign: "center",
              fontFamily: "Poppins",
            }}
          >
            Request & Collect stock
          </Typography>
        </Box>

        {/* Request Section */}
        <Box sx={{ m: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                mb: "1vw",
                fontWeight: 500,
                lineHeight: "100%",
                fontSize: ".8vw",
                color: "#101010",
                letterSpacing: "0%",
                fontFamily: "Poppins",
              }}
            >
              Request
            </Typography>
            <Typography
              sx={{
                mb: "1vw",
                fontWeight: 400,
                lineHeight: "100%",
                fontSize: ".7vw",
                color: "#404040",
                letterSpacing: "0%",
                fontFamily: "Poppins",
              }}
            >
              Max: 3
            </Typography>
          </Box>
          <Select
            fullWidth
            multiple
            value={requestTray}
            onChange={handleRequestChange}
            displayEmpty
            open={selectOpen?.request}
            onOpen={() => handleSelectOpen("request")}
            onClose={handleSelectClose}
            input={
              <OutlinedInput
                fullWidth
                endAdornment={
                  <InputAdornment position="start">
                    <Box
                      sx={{
                        transition: "transform 0.3s ease",
                        transform: selectOpen?.request
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        position: "absolute",
                        right: ".6vw",
                        top: "25%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectOpen("request");
                      }}
                    >
                      <ArrowDown />
                    </Box>
                  </InputAdornment>
                }
              />
            }
            renderValue={(selected) =>
              selected.length === 0 ? (
                <Typography className="placeholder-label">
                  Choose Tray
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: ".25vw",
                    maxHeight: "5vw",
                    padding: "0vw 0vw",
                    width: "90%",
                    overflowY: "auto",
                  }}
                >
                  {selected.map((value) => (
                    <Chip
                      sx={{
                        height: "1.7vw",
                      }}
                      key={value}
                      label={value}
                      deleteIcon={getIcon("Cross")}
                      onDelete={() => {
                        setRequestTray((prev) =>
                          prev.filter((item) => item !== value)
                        );
                      }}
                      onMouseDown={(e) => e.stopPropagation()}
                      className="modal-chip"
                    />
                  ))}
                </Box>
              )
            }
            MenuProps={MenuProps}
            sx={{
              marginTop: ".6vw",
              fontFamily: "Karla",
              fontSize: ".9vw",
              lineHeight: "1.1vw",
              fontWeight: 500,
              // maxHeight: "5vw !important",
              borderRadius: ".25vw",
              textTransform: "none",
              backgroundColor: "#FFFFFF",
              border: ".05vw solid #000000",
              padding: "0vw .25vw !important",
              "& .MuiSelect-select": {
                padding: ".5vw .25vw !important",
                maxHeight: "4vw !important",
              },
              "& .MuiSelect-icon": {
                display: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:focus": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                cursor: "default",
                mb: 1,
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
              onClick={(e) => e.stopPropagation()} // prevent dropdown from closing
            >
              <OutlinedInput
                size="small"
                fullWidth
                value={requestSearchTerm}
                onChange={(e) => setRequestSearchTerm(e.target.value)}
                placeholder="Search Tray ..."
                onKeyDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                startAdornment={
                  <InputAdornment position="start">
                    {getIcon("Search", "dark")}
                  </InputAdornment>
                }
                sx={{
                  border: "1px solid #000",
                  height: "2.2vw",
                  fontSize: ".75vw",
                  color: "#000",
                  "& input::placeholder": {
                    opacity: 1,
                    color: "#999",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused": {
                    boxShadow: "none",
                    border: "1px solid #000",
                  },
                }}
              />
            </Box>
            {filteredOptions?.map((name) => (
              <MenuItem
                key={name}
                value={name}
                onClick={() => setRequestSearchTerm("")}
                sx={{
                  fontSize: ".75vw",
                  mb: ".3vw",
                  backgroundColor:
                    trayStatusMap[name] === "available"
                      ? "#FFFFFF"
                      : trayStatusMap[name] === "occupied"
                      ? "#FFD70026"
                      : trayStatusMap[name] === "requested"
                      ? "#E77B7B52"
                      : "#FFFFFF",
                  "&.Mui-selected": {
                    backgroundColor:
                      trayStatusMap[name] === "available"
                        ? "#FFFFFF"
                        : trayStatusMap[name] === "occupied"
                        ? "#FFD70026"
                        : trayStatusMap[name] === "requested"
                        ? "#E77B7B52"
                        : "#FFFFFF",
                    borderRadius: ".25vw",
                  },
                }}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <hr style={{ color: "#EDEDEB", width: "100%", marginBottom: "2vw" }} />

        <Box sx={{ m: 3 }}>
          <Typography
            sx={{
              fontWeight: 500,
              lineHeight: "100%",
              fontSize: ".8vw",
              color: "#101010",
              letterSpacing: "0%",
              fontFamily: "Poppins",
            }}
          >
            Collect
          </Typography>
          <Select
            fullWidth
            multiple
            value={collectTray}
            onChange={handleCollectChange}
            displayEmpty
            open={selectOpen.collect}
            onOpen={() => handleSelectOpen("collect")}
            onClose={handleSelectClose}
            input={
              <OutlinedInput
                fullWidth
                endAdornment={
                  <InputAdornment position="start">
                    <Box
                      sx={{
                        transition: "transform 0.3s ease",
                        transform: selectOpen.collect
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        position: "absolute",
                        right: ".6vw",
                        top: "25%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectOpen("collect");
                      }}
                    >
                      <ArrowDown />
                    </Box>
                  </InputAdornment>
                }
              />
            }
            renderValue={(selected) =>
              selected.length === 0 ? (
                <Typography className="placeholder-label">
                  Choose Tray
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: ".25vw",
                    maxHeight: "5vw",
                    padding: "0vw 0vw",
                    width: "90%",
                    overflowY: "auto",
                  }}
                >
                  {selected.map((value) => (
                    <Chip
                      sx={{
                        height: "1.7vw",
                      }}
                      key={value}
                      label={value}
                      deleteIcon={getIcon("Cross")}
                      onDelete={() => {
                        setCollectTray((prev) =>
                          prev.filter((item) => item !== value)
                        );
                      }}
                      onMouseDown={(e) => e.stopPropagation()}
                      className="modal-chip"
                    />
                  ))}
                </Box>
              )
            }
            MenuProps={MenuProps}
            sx={{
              marginTop: ".6vw",
              fontFamily: "Karla",
              fontSize: ".9vw",
              lineHeight: "1.1vw",
              fontWeight: 500,
              // maxheight: "4vw",
              borderRadius: ".25vw",
              textTransform: "none",
              backgroundColor: "#FFFFFF",
              border: ".05vw solid #000000",
              padding: "0 .25vw !important",
              "& .MuiSelect-select": {
                padding: ".5vw .25vw !important",
              },
              "& .MuiSelect-icon": {
                display: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:focus": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                cursor: "default",
                mb: 1,
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
              onClick={(e) => e.stopPropagation()} // prevent dropdown from closing
            >
              <OutlinedInput
                size="small"
                fullWidth
                value={collectSearchTerm}
                onChange={(e) => setCollectSearchTerm(e.target.value)}
                placeholder="Search Tray ..."
                onKeyDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                startAdornment={
                  <InputAdornment position="start">
                    {getIcon("Search", "dark")}
                  </InputAdornment>
                }
                sx={{
                  border: "1px solid #000",
                  height: "2.2vw",
                  fontSize: ".75vw",
                  color: "#000",
                  "& input::placeholder": {
                    opacity: 1,
                    color: "#999",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused": {
                    boxShadow: "none",
                    border: "1px solid #000",
                  },
                }}
              />
            </Box>
            {filteredCollectOptions?.map((name) => (
              <MenuItem
                key={name}
                value={name}
                sx={{
                  fontSize: ".75vw",
                  "&.Mui-selected": {
                    backgroundColor: "#D9D9D9",
                    borderRadius: ".25vw",
                  },
                }}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", m: 3 }}>
          <button
            onClick={handleSubmit}
            style={{
              backgroundColor:
                requestTray?.length > 0 || collectTray?.length > 0
                  ? "#50C878"
                  : "#4D4D4D",
              color:
                requestTray?.length > 0 || collectTray?.length > 0
                  ? "#000000"
                  : "#FFFFFF",
              padding: ".8vw 1.6vw",
              borderRadius: ".25vw",
              border: "none",
              cursor: "pointer",
              fontFamily: "Karla",
              fontSize: ".8vw",
              fontWeight: 600,
              textTransform: "uppercase",
              width: "100%",
              transition: "all 0.2s ease",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            {submitting ? "SUBMITTING..." : "SUBMIT"}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SalesPersonModal;

